import {
  ANSWER_QUESTION_FAIL,
  ANSWER_QUESTION_RESET,
  ANSWER_QUESTION_START,
  ANSWER_QUESTION_SUCCESS,
} from "./constants";
import {AnswerQuestionActions, AnswerQuestionState} from "./types";

const initialState: AnswerQuestionState = {
  loading: false,
  data: undefined,
  error: undefined,
}

const reducer = (
  state = initialState,
  action: AnswerQuestionActions,
): AnswerQuestionState => {
  switch (action.type) {
    case ANSWER_QUESTION_START:
      return {
        ...initialState,
        loading: true,
      }
    case ANSWER_QUESTION_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      }
    case ANSWER_QUESTION_FAIL:
     return {
        ...state,
        loading: false,
        error: action.error,
      }
    case ANSWER_QUESTION_RESET:
      return {
        ...initialState,
      }
    default:
      return state;
  }
}

export default reducer;
